import { useRouter } from 'next/router';
import React from 'react';
import { tabs } from '../..';
import { TextSmall } from '@/components/Texts';

const cookiesData = [
  {
    name: 'Technical cookies',
    desc: 'these are mandatory to move around the website, use basic functions and ensure the security of the website; they do not collect information about you for marketing purposes, nor do they store which web pages you have visited;',
  },
  {
    name: 'Performance cookies',
    desc: 'these collect information about how you use our website, which pages you visit and, for example, whether errors occur during website use; they do not collect information that could identify you - all information collected is anonymous and is used only to improve our website and find out what interests our users;',
  },
  {
    name: 'Advertising cookies, targeting cookies',
    desc: 'These are used to offer the website user tailored advertising on the website or offers from third parties and to measure the effectiveness of these offers; advertising and targeting cookies are stored for a maximum of 13 months;',
  },
  {
    name: 'Sharing cookies',
    desc: 'These are used to improve the interactivity of our website with other services (e.g. social networks); sharing cookies are stored for a maximum of 13 months.',
  },
];

const UseCookiesPluginsServices = () => {
  const router = useRouter();
  return (
    <>
      <TextSmall fontWeight={700}>
        (5) Use of cookies, plugins and other services on our website
      </TextSmall>
      <TextSmall fontWeight={700}>a) Cookie</TextSmall>
      <TextSmall>
        We use cookies on our websites. Cookies are small text files that are
        assigned to the browser you are using and stored on your hard drive by
        means of a characteristic character string and through which certain
        information flows to the body that sets the cookie. Cookies cannot
        execute programs or transfer viruses to your computer and therefore
        cannot cause any damage. They serve to make the Internet offer as a
        whole more user-friendly and effective, i.e. more pleasant for you.
      </TextSmall>
      <TextSmall>
        Cookies can contain data that makes it possible to recognize the device
        used. In some cases, however, cookies only contain information about
        certain settings that are not personally identifiable. However, cookies
        cannot directly identify a user.
      </TextSmall>
      <TextSmall>
        A distinction is made between session cookies, which are deleted as soon
        as you close your browser, and permanent cookies, which are stored
        beyond the individual session. With regard to their function, a
        distinction is made between cookies:
      </TextSmall>
      {cookiesData.map((item, index) => {
        return (
          <TextSmall pl={8} key={index + 'cookies'}>
            {' '}
            <TextSmall as='span' fontWeight={'semibold'}>
              {' '}
              - &quot;{item.name} &quot;{' '}
            </TextSmall>{' '}
            : {item.desc}
          </TextSmall>
        );
      })}
      <TextSmall>
        The legal basis for cookies that are absolutely necessary to provide you
        with the expressly requested service is Article 6 (1) sentence 1 lit. a
        GDPR. Any use of cookies that is not absolutely technically necessary
        for this purpose constitutes data processing that is only permitted with
        your express and active consent pursuant to Article 6 (1) sentence 1
        lit. a GDPR. This applies in particular to the use of performance,
        advertising, targeting or sharing cookies. In addition, we will only
        disclose your personal data processed through cookies to third parties
        if you have given your express consent to do so in accordance with Art.
        6 (1) p. 1 lit. a GDPR.
      </TextSmall>{' '}
      <TextSmall fontWeight={700}>b) Cookie Policy</TextSmall>
      <TextSmall>
        For more information about which cookies we use and how you can manage
        your cookie settings and disable certain types of tracking, please see
        our
        <TextSmall
          as={'span'}
          color={'blue'}
          cursor={'pointer'}
          onClick={() => {
            router.push(`?tab=${tabs['cookies-policy'].value}`, undefined, {
              shallow: true,
              scroll: true,
            });
          }}
        >
          Cookie Policy
        </TextSmall>
        .
      </TextSmall>
      <TextSmall fontWeight={700}>c) Social media plugins</TextSmall>
      <TextSmall>
        We do not use social media plugins on our websites. If our websites
        contain icons of social media providers, we only use these for passive
        linking to the pages of the respective providers.
      </TextSmall>
    </>
  );
};

export default UseCookiesPluginsServices;
